import React, { useState } from 'react';
import classnames from 'classnames';
import Item from './Item';
import * as styles from './dropdown.module.scss';

const Dropdown = ({ DropdownData }) => {
  const [dropdown, setDropdown] = useState(false);

  const toggleDropdown = () => setDropdown(!dropdown);

  return (
    <div className={classnames(styles.dropdown)}>
      <button
        onClick={toggleDropdown}
        type="button"
        className={classnames(
          styles.btn,
          dropdown && styles.dropdownOpen,
          'cr-subheader-2'
        )}
      >
        <span>{DropdownData.button}</span>
      </button>

      <ul className={classnames(styles.list, dropdown && styles.listShow)}>
        {DropdownData.list.map((item, i) => {
          return (
            <li key={i}>
              <Item ItemData={item} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Dropdown;
